export const ADD_DETAILS = "ADD_DETAILS"
export const ADD_SERVICES = "ADD_SERVICES"
export const ADD_ABOUT_ME_SKILLS = "ADD_ABOUT_ME_SKILLS"
export const ADD_ATTACHMENTS = "ATTACHMENTS"
export const ADD_SOCIAL_PROFILES = "ADD_SOCIAL_PROFILES"
export const ADD_RESUME_BIO = "ADD_RESUME_BIO"
export const ADD_SKILLS = "ADD_SKILLS"
export const ADD_SKILL_BUTTONS = "ADD_SKILL_BUTTONS"
export const ADD_PROFESSIONAL_EXPERIENCE = "ADD_PROFESSIONAL_EXPERIENCE"
export const ADD_ACADEMIC_BACKGROUND = "ADD_ACADEMIC_BACKGROUND"